/* global btoa */
import { showError } from 'utils/messages';
import { appUrl } from 'utils/wrappers';

import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #get_rates_form': 'submit',
  },

  submit(e) {
    e.preventDefault();

    const data = {
      shipment: {
        from_address: {
          name: this.$('input#from_address-name').val(),
          company: this.$('input#from_address-company').val(),
          street1: this.$('input#from_address-street1').val(),
          street2: this.$('input#from_address-street2').val(),
          city: this.$('input#from_address-city').val(),
          state: this.$('input#from_address-state').val(),
          zip: this.$('input#from_address-zip').val(),
          country: this.$('input#from_address-country').val(),
          phone: this.$('input#from_address-phone').val(),
        },
        to_address: {
          name: this.$('input#to_address-name').val(),
          company: this.$('input#to_address-company').val(),
          street1: this.$('input#to_address-street1').val(),
          street2: this.$('input#to_address-street2').val(),
          city: this.$('input#to_address-city').val(),
          state: this.$('input#to_address-state').val(),
          zip: this.$('input#to_address-zip').val(),
          country: this.$('input#to_address-country').val(),
          phone: this.$('input#to_address-phone').val(),
        },
        parcel: {
          length: this.$('input#parcel-length').val(),
          width: this.$('input#parcel-width').val(),
          height: this.$('input#parcel-height').val(),
          weight: this.$('input#parcel-weight').val(),
        },
      },
    };

    const self = this;
    $.ajax({
      async: true,
      url: appUrl('shipments'),
      type: 'POST',
      dataType: 'json',
      data,
      beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', `Basic ${btoa('cueqNZUb3ldeWTNX7MU3Mel8UXtaAMUi:')}`);
      },
      success(res) {
        self.collection.reset(res.rates);
      },
      error() {
        self.collection.reset([]);
        showError('Rates could not be retrieved for the given shipment parameters.');
      },
    });
  },
});




// WEBPACK FOOTER //
// ./app/components/pages/shipping_calculator/form/index.js